import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Module from "./module";
import OptionsModal, { active_category_type } from "./options_modal";
import SelectedOptions from "./selected_options";
import RecommandedFlag from "./recommanded_flag";
import Toggle from "./toggle";
import Button from "./button";
import Capacities from "./capacities";
import LoadingSpinner from "./loading_spinner";
import Scrollbars from "react-custom-scrollbars";

// Mobile fixed panel
const FixedMobilePopup = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  position: fixed;
  top: 0px;right:0px;bottom:0px;left:0px;
  z-index: 9999;
  background-color: white;
`;

const MobilePopupHeader = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 5px;
`;

const MobilePopupHomeIcon = styled.svg`
  width: 16px;
  height: 16px;
  margin-right: 5px;
  cursor: pointer;
`;

const MobilePopupHome = styled.span`
  color: #626469;
  font-size: 16px;
  font-weight: 400;
`;

const MobileCategoryName = styled.span`
  color: #626469;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 5px;
`;

const MobilePopupScrollbarWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;
  margin-right: -16px;
  margin-top: 10px;
`;

const MobilePopupScrollbarContent = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 16px;
`;

const MobileArrow = styled.svg`
  box-sizing: content-box;
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  color: #434B4D;
`;

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 16px 16px 10px 16px;

  ${props => props.displayType === 'flat' ? `` : `
    ${props.hasSelectedOptions ? `border-left: 4px solid ${props.color ? props.color : "#008a16"};` : "border-left: 4px solid #9FA0A4;"}
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
    border-radius: 0px 4px 4px 0px;
  `}

  margin-bottom: 15px;

  ${props => props.disabled ? `opacity: 0.5; pointer-events: none;` : ''}

  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 16px 10px 10px 10px;
    cursor: pointer;
  }
`;

const PresentationAndArrowWrapper = styled.div`
  display: flex;
  align-items: center;
  ${props => props.expand ? 'flex: 1 1 0px;' : ''}
`;

const ItemPresentationWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;
`;

const ItemImage = styled.img`
  width: 80px;
  height: 80px;
  margin-right: 10px;
`;

const ModuleInformationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
`;

const DescriptionAndAdditionalInformationWrapper = styled.div`
  margin-top: 5px;
  display: flex;
  flex-wrap: wrap;
  overflow-x: hidden;
`;

const Description = styled.span`
  font-weight: 400;
  font-size: 16px;
  color: #494b50;
  margin-right: 30px;
  margin-top: 5px;

  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    -webkit-line-clamp: 2;
    overflow: hidden;
    -webkit-box-orient: vertical;
    display: -webkit-box;
  }
`;

const AddtionalInformationRow = styled.div`
  display: flex;
  margin-top: 5px;
`;

// CSS trick to hide the separator when it wraps. Combined with the overflow-x hidden from above.
const AdditonalInformationWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1 0 calc(50% - 20px);
  padding-left: 20px;
  margin-left: -20px;

  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    display: none;
  }
`;

const MobileAdditionalInformationWrapper = styled.div`
  display: none;
  margin-top: 10px;
  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    display: flex;
    flex-direction: column;
  }
`;

const LinkWrapper = styled.div`
  display: inline-flex;
  font-weight: 700;
  justify-content: space-between;
  flex-wrap: wrap-reverse;
`;

const AdditionalInformationKey = styled.div`
  font-weight: 400;
  font-size: 16px;
  color: #494b50;
  white-space: nowrap;
  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    white-space: unset;
  }
`;

const AdditionalInformationValue = styled(AdditionalInformationKey)`
  font-weight: bold;
  margin-left: 10px;
`;

const Separator = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  border-left: 1px solid rgba(0, 0, 0, 0.2);
`;

const ModulesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`;

const ItemInformationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
`;

const DisplayText = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: ${props => props.color ? props.color : '#42B4E6'};
`;

const DisplayItemsWrapper = styled.div`
  display: flex;
  margin-left: 20px;
`;

const DisplayItems = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  :hover {
    ${DisplayText} {
      text-decoration: underline;
    }
  }
`;

const DisplayArrow = styled.div`
  width: 24px;
  height: 24px;
  padding: 4px;
  box-sizing: border-box;
  transition: transform 250ms;
  transform: ${(props) => (props.isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  margin-left: 5px;
  color: ${props => props.color ? props.color : '#42B4E6'};
`;

const ItemActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    align-items: unset;
  }
`;

const QuantityAndBulkWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;
  margin-right: 5px;

  border-radius: 8px;
  border: 0.5px solid #DBDBDC;
  background-color: #F7F7F7;
  padding: 5px 20px;

  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    justify-content: space-between;
  }
`;

const BulkAndToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-left: 20px;
  justify-content: center;
`;

const BulkLabel = styled.span`
  font-weight: 400;
  font-size: 16px;
  color: #494B50;
  margin-right: 10px;
  text-align: center;
`;


const QuantityWrapper = styled.div`
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #626469;
`;

const QuantityLabel = styled.span``;

const QuantityNumber = styled.span`
  font-weight: bold;
  margin-left: 5px;
`;

const AddOptionsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-self: flex-end;
`;

const SlotWrapper = styled.div`
  display: flex;
  margin-top: 5px;
`;

const SlotLabel = styled.span``;

const SlotRow = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.color ? props.color : '#42B4E6'};
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
  padding: 0px 16px;

  border-radius: 2px;
  border: 1px solid ${props => props.color ? props.color : '#42B4E6'};

  :hover {
    ${SlotLabel} {
      text-decoration: underline;
    }
  }
`;

const SlotIconWrapper = styled.div`
  margin-right: 5px;
  width: 24px;
  height: 24px;
`;

const DesktopCapacitiesAndSlotWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    display: none;
  }
`;

const CapacitiesWrapper = styled.div`
  display: flex;
  margin-right: 5px;
`;

const NoOptionsLabel = styled.span`
  align-self: center;
  border-radius: 100px;
  background: #9FA0A466;
  color: #0F0F0F;
  font-size: 14px;
  font-weight: 400;
  padding: 5px 12px;
`;

const ButtonMargin = styled.div`
  margin-right: 10px;
`;

const DesktopVisible = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    display: none;
  }
`;

const MobileVisible = styled.div`
  display: none;
  flex-direction: column;

  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    display: flex;
  }
`;

const CardAddOptionsWrapper = styled.div`
  display: flex;
  height: 100%;

  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    display: none;
  }
`;

const SpinnerWrapper = styled.div`
  align-self: flex-end;
`;

const DescriptionComponent = styled.div`
  display: flex;
  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    display: none;
  }
`;

const MobileDescriptionComponent = styled.div`
  display: none;
  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    display: flex;
  }
`;

const MultipleDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 calc(50% - 20px);
`;

const MultipleDescriptionId = styled.span`
  font-weight: 700;
`;

const MobileAddOptionWrapper = styled.div`
  display: flex;
  margin-top: 10px;
`;

class ModuleItem extends React.Component {
  static propTypes = {
    categoryName: PropTypes.string,
    displayType: PropTypes.string,
    moduleItem: PropTypes.object,
    isSaving: PropTypes.bool,
    renderProductLink: PropTypes.func,
    mobileBreakpoint: PropTypes.number,
    primaryColor: PropTypes.string,
    primaryTextColor: PropTypes.string,
    secondaryColor: PropTypes.string,
    secondaryTextColor: PropTypes.string,
    getLabel: PropTypes.func,
    getAndReplaceLabel: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      modalOpen: false,
      defaultModalActiveCategoryType: null,
      defaultModalAccessoryToView: null,
      defaultOptionTypes: null,
      showOptions: false,
      bulkAccessorize: true,
      modulesForBulk: [],
      showMobilePopup: false,
      statusToFilter: null,
      disablePreviousOnEdit: false
    };
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount = () => {
    this._isMounted = false;
  }

  updateStateIfMounted = (newState) => {
    if (this._isMounted) {
      this.setState(newState);
    }
  }

  renderAdditionalInformation = () => {
    const additionalInformation =
      this.props.moduleItem.additionalInformation || [];
    if (additionalInformation.length === 0) {
      return null;
    }

    return (
      <AdditonalInformationWrapper
        mobileBreakpoint={this.props.mobileBreakpoint}
      >
        {additionalInformation.map((additionalInformation, idx) => {
          return (
            <AddtionalInformationRow key={idx}>
              <AdditionalInformationKey>
                {additionalInformation.name}
              </AdditionalInformationKey>
              <AdditionalInformationKey>:</AdditionalInformationKey>
              <AdditionalInformationValue>
                {additionalInformation.value}
              </AdditionalInformationValue>
            </AddtionalInformationRow>
          );
        })}
        <Separator></Separator>
      </AdditonalInformationWrapper>
    );
  };

  renderMobileAdditionalInformation = () => {
    const additionalInformation =
      this.props.moduleItem.additionalInformation || [];
    if (additionalInformation.length === 0) {
      return null;
    }

    return (
      <MobileAdditionalInformationWrapper
        mobileBreakpoint={this.props.mobileBreakpoint}
      >
        {additionalInformation.map((additionalInformation, idx) => {
          return (
            <AddtionalInformationRow key={idx}>
              <AdditionalInformationKey
                mobileBreakpoint={this.props.mobileBreakpoint}
              >
                {additionalInformation.name}
              </AdditionalInformationKey>
              <AdditionalInformationKey>:</AdditionalInformationKey>
              <AdditionalInformationValue
                mobileBreakpoint={this.props.mobileBreakpoint}
              >
                {additionalInformation.value}
              </AdditionalInformationValue>
            </AddtionalInformationRow>
          );
        })}
      </MobileAdditionalInformationWrapper>
    );
  };

  renderCapacitiesAndSlot = () => {
    return (
      <>
        {this.props.moduleItem?.modules?.length === 1 && <>
          {this.props.moduleItem?.modules[0]?.capacities && <CapacitiesWrapper> <Capacities capacities={this.props.moduleItem?.modules[0]?.capacities}>
          </Capacities></CapacitiesWrapper>}
          {this.props.moduleItem?.modules[0]?.location && <SlotWrapper>
              <SlotRow color={this.props.primaryColor} onClick={(event) => {
                event.preventDefault();
                if (this.props.moduleItem?.modules[0]?.location?.onClick) {
                  this.props.moduleItem.modules[0].location.onClick();
                }
              }}>
                <SlotIconWrapper>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="currentColor" d="M512 628c5 0 10-1 15-4l6-4 2-4c28-46 57-92 85-137 33-45 57-95 72-149l1-2-1-37c-7-92-85-163-177-163h-4c-92 0-170 71-178 165v32l1 5c14 54 38 104 70 147 29 50 60 99 86 139 5 8 14 12 22 12zM375 322v-27c6-70 65-125 137-124h3c70 0 129 54 135 122v29c-14 47-35 92-66 133l-72 117c-22-36-47-76-72-119-29-40-51-84-65-131zm137 68c47 0 85-38 85-85s-38-84-85-84-84 37-84 84 37 85 84 85zm0-127c23 0 42 19 42 42s-19 42-42 42-42-19-42-42 19-42 42-42zm363 633c6 0 12-3 16-8s6-12 4-18l-90-379c-2-9-10-16-20-16h-70c-12 0-22 9-22 21s10 22 22 22h53l80 335H177l85-335h46c12 0 22-10 22-22s-10-21-22-21h-62c-10 0-19 7-21 16l-96 378c-2 7-1 14 3 19 5 5 11 8 17 8h726z"/></svg>
                </SlotIconWrapper>
                <SlotLabel>{this.props.moduleItem?.modules[0].location.label}</SlotLabel>
              </SlotRow>
            </SlotWrapper>}
        </>}
      </>
    );
  }

  /**
   * Checks if any of the modules have an option selected.
   *
   * @returns true if any of the modules have an option selected, false otherwise
   */
  hasSelectedOptions = () => {
    let result = false;
    for (let i = 0; i < (this.props.moduleItem.modules || []).length && !result; i++) {
      const mod = this.props.moduleItem.modules[i];
      if (mod.selectedOptions && ((mod.selectedOptions?.accessories || []).length > 0 || (mod.selectedOptions?.services || []).length > 0)) {
        result = true;
      }
    }

    return result;
  }

  renderNoOptionsLabel = () => {
    return (<>
      {!this.props.moduleItem.preventCardDisabledWhenNoOptions && <NoOptionsLabel>{this.props.getLabel('options_screen.no_options_available')}</NoOptionsLabel>}
    </>);
  }

  renderAddOptionsButtons = (hasOptions) => {
    return (<>
      {hasOptions ? (this.state.bulkAccessorize || (this.state.modulesForBulk.length > 0)) && <AddOptionsWrapper>
          {(this.props.moduleItem.optionsAvailable?.accessories || []).length > 0 && <ButtonMargin>
            <Button id={`${this.props.moduleItem.deviceIdentification.identificationKey}-add-accessories`} icon={'plus-large'} disabled={this.props.isSaving} onClick={(event) => { event.stopPropagation(); this.setState({ modalOpen: true, defaultModalActiveCategoryType: active_category_type.accessories, defaultModalAccessoryToView: null, defaultOptionTypes: null, statusToFilter: null, disablePreviousOnEdit: false });}} label={this.props.getLabel('options_screen.add_accessories')}></Button>
          </ButtonMargin>}
          {(this.props.moduleItem.optionsAvailable?.services || []).length > 0 && <Button id={`${this.props.moduleItem.deviceIdentification.identificationKey}-add-services`}  icon={'plus-large'} disabled={this.props.isSaving} onClick={(event) => { event.stopPropagation(); this.setState({ modalOpen: true, defaultModalActiveCategoryType: active_category_type.services, defaultModalAccessoryToView: null, defaultOptionTypes: null, statusToFilter: null, disablePreviousOnEdit: false });}} label={this.props.getLabel('options_screen.add_services')}></Button>}
        </AddOptionsWrapper> : this.renderNoOptionsLabel()}
    </>);
  }

  renderMobileAddOptionsButtons = (hasOptions) => {
    return (
      <>
        {hasOptions ? (this.state.bulkAccessorize || (this.state.modulesForBulk.length > 0)) && (this.props.moduleItem.optionsLoading ? <LoadingSpinner></LoadingSpinner> : <>
          {(this.props.moduleItem.optionsAvailable?.accessories || []).length > 0 && <Button expand={true} disabled={this.props.isSaving} onClick={(event) => { event.stopPropagation(); this.setState({ modalOpen: true, defaultModalActiveCategoryType: active_category_type.accessories, defaultModalAccessoryToView: null, defaultOptionTypes: null, statusToFilter: null, disablePreviousOnEdit: false });}} label={this.props.getLabel('options_screen.add_accessories')} icon={'plus-large'}>
          </Button>}
          {(this.props.moduleItem.optionsAvailable?.services || []).length > 0 && <MobileAddOptionWrapper><Button expand={true} disabled={this.props.isSaving} onClick={(event) => { event.stopPropagation(); this.setState({ modalOpen: true, defaultModalActiveCategoryType: active_category_type.services, defaultModalAccessoryToView: null, defaultOptionTypes: null, statusToFilter: null, disablePreviousOnEdit: false });}} label={this.props.getLabel('options_screen.add_services')} icon={'plus-large'}>
          </Button></MobileAddOptionWrapper>}
        </>) : this.renderNoOptionsLabel()}
      </>
    );
  }

  renderSubModules = (forceShowSubModules = false) => {
    return (
      <>
        {this.props.moduleItem?.modules?.length > 1 && (this.state.isOpen || !this.state.bulkAccessorize || forceShowSubModules) && (
          <ModulesWrapper mobileBreakpoint={this.props.mobileBreakpoint}>
            {this.props.moduleItem.modules.map((module, idx) => {
              return (
                <Module
                  key={idx}
                  module={module}
                  isSaving={this.props.isSaving}
                  renderProductLink={this.props.renderProductLink}
                  mobileBreakpoint={this.props.mobileBreakpoint}
                  primaryColor={this.props.primaryColor}
                  primaryTextColor={this.props.primaryTextColor}
                  secondaryColor={this.props.secondaryColor}
                  secondaryTextColor={this.props.secondaryTextColor}
                  categoryName={this.props.categoryName}
                  getLabel={this.props.getLabel}
                  getAndReplaceLabel={this.props.getAndReplaceLabel}
                  canAddOptions={!this.state.bulkAccessorize && this.state.modulesForBulk.length === 0}
                  bulkAccessorize={this.state.bulkAccessorize}
                  modulesForBulk={this.state.modulesForBulk}
                  onToggleModuleForBulk={(identificationKey, newStatus) => {
                    if (newStatus) {
                      this.setState({modulesForBulk: [...this.state.modulesForBulk, identificationKey]});
                    } else {
                      this.setState({modulesForBulk:  this.state.modulesForBulk.filter((deviceKey) => deviceKey !== identificationKey)});
                    }
                  }}
                ></Module>
              );
            })}
          </ModulesWrapper>
        )}
      </>);
  }

  renderBulkToggleSection = () => {
    return (
      <>
        {this.props.moduleItem?.modules?.length > 1 && <ItemActionsWrapper mobileBreakpoint={this.props.mobileBreakpoint}>
          <QuantityAndBulkWrapper mobileBreakpoint={this.props.mobileBreakpoint}>
            <QuantityWrapper>
              <QuantityLabel>{`${this.props.getLabel('options_screen.quantity')}:`}</QuantityLabel>
              <QuantityNumber>{this.props.moduleItem?.modules?.length}</QuantityNumber>
            </QuantityWrapper>
            <BulkAndToggleWrapper>
              <BulkLabel>{this.props.getLabel('options_screen.accessorize_all_at_once')}</BulkLabel>
              <Toggle id={`${this.props.moduleItem.deviceIdentification.identificationKey}-bulk-accessorize`} active={this.state.bulkAccessorize || (!this.state.bulkAccessorize && ((this.props.moduleItem?.modules || []).length === this.state.modulesForBulk.length))} color={this.props.secondaryColor} onToggle={() => {
                  if (this.state.bulkAccessorize || ((this.props.moduleItem?.modules || []).length !== this.state.modulesForBulk.length)) {
                    const newState = !this.state.bulkAccessorize;
                    let modulesForBulk = [];
                    if (newState) {
                      modulesForBulk = (this.props.moduleItem?.modules || []).map((mod) => mod.deviceIdentification?.identificationKey);
                    }
                    this.setState({bulkAccessorize: newState, modulesForBulk});
                  }
                }}>
              </Toggle>
            </BulkAndToggleWrapper>
            {this.state.bulkAccessorize && <DesktopVisible mobileBreakpoint={this.props.mobileBreakpoint}><DisplayItemsWrapper>
              <DisplayItems id={`${this.props.moduleItem.deviceIdentification.identificationKey}-toggle-bulk-view`} mobileBreakpoint={this.props.mobileBreakpoint} onClick={(event) => {event.stopPropagation(); this.setState({ isOpen: !this.state.isOpen });}}>
                <DisplayText color={this.props.primaryColor}>{this.props.getLabel(this.state.isOpen  ? 'options_screen.hide_items' : 'options_screen.show_items')}</DisplayText>
                <DisplayArrow isOpen={this.state.isOpen} color={this.props.primaryColor}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
                    <path
                      fill="currentColor"
                      d="M134 347.2C126 339.2 126 325.2 134 317.2C138 313.2 144 311.2 149 311.2C155 311.2 160 313.2 164 317.2L510.6 663.5L860 315.5C864 311.5 869 309.5 875 309.5C880 309.5 886 311.5 890 315.5C898 323.5 898 337.5 890 345.5L526.6 708.5C517.6 716.5 504.6 716.5 495.6 708.5L134 347.2Z"
                    />
                  </svg>
                </DisplayArrow>
              </DisplayItems>
            </DisplayItemsWrapper></DesktopVisible>}
          </QuantityAndBulkWrapper>
        </ItemActionsWrapper>}
      </>
    );
  }

  buildDescription = (descObj, shouldRenderReferenceId) => {
    if (shouldRenderReferenceId) {
      return <><MultipleDescriptionId>{descObj.id}</MultipleDescriptionId>: {descObj.description}</>
    }

    return <>{descObj.description}</>;
  }

  renderDescription = () => {
    if (this.props.moduleItem.multipleDescriptions) {
      const shouldRenderReferenceId = this.props.moduleItem.multipleDescriptions.length > 1;

      return (
        <MultipleDescriptionWrapper>
          {this.props.moduleItem.multipleDescriptions.map((descObj, idx) => <Description key={idx} mobileBreakpoint={this.props.mobileBreakpoint}>
            {this.buildDescription(descObj, shouldRenderReferenceId)}
          </Description>)}
        </MultipleDescriptionWrapper>
      );
    }

    return (
      <MultipleDescriptionWrapper>
        <Description mobileBreakpoint={this.props.mobileBreakpoint}>
          {this.props.moduleItem.description}
        </Description>
      </MultipleDescriptionWrapper>
    );
  }

  renderSelectedOptions = () => {
    return (
      <SelectedOptions
        renderProductLink={this.props.renderProductLink}
        primaryColor={this.props.primaryColor}
        primaryTextColor={this.props.primaryTextColor}
        secondaryColor={this.props.secondaryColor}
        secondaryTextColor={this.props.secondaryTextColor}
        isSaving={this.props.isSaving}
        getLabel={this.props.getLabel}
        moduleItem={this.props.moduleItem?.modules[0]}
        optionsLoading={this.props.moduleItem?.optionsLoading}
        onAddMore={(optionCategory) => {
          this.setState({modalOpen: true, defaultModalActiveCategoryType: optionCategory, defaultModalAccessoryToView: null, defaultOptionTypes: null, statusToFilter: null, disablePreviousOnEdit: false });
          }}
          onViewAccessory={(optionItem, optionCategory, statusToFilter, disablePreviousOnEdit) => {
          this.setState({modalOpen: true, defaultModalActiveCategoryType: optionCategory, defaultModalAccessoryToView: optionItem, defaultOptionTypes: optionItem.optionTypes, statusToFilter, disablePreviousOnEdit});
          }}
        >
      </SelectedOptions>
    );
  }

  renderModuleInformation = (hasOptions, showSelectedOptions = true, expand = true) => {
    const hasDescriptionComponent = this.props.moduleItem.renderDescriptionComponent != null;

    return(
      <>
      <PresentationAndArrowWrapper expand={expand}>
            <ItemInformationWrapper>
              <ItemPresentationWrapper>
                <ItemImage src={this.props.moduleItem.imageUrl}></ItemImage>
                <ModuleInformationWrapper>
                  <LinkWrapper>
                    {this.props.renderProductLink(
                      this.props.moduleItem.moduleId
                    )}
                  </LinkWrapper>
                  {hasDescriptionComponent ? <DescriptionComponent mobileBreakpoint={this.props.mobileBreakpoint}>
                    {this.props.moduleItem.renderDescriptionComponent()}
                    </DescriptionComponent> : <DescriptionAndAdditionalInformationWrapper>
                      {this.renderDescription()}
                      {this.renderAdditionalInformation()}
                  </DescriptionAndAdditionalInformationWrapper>}
                  <DesktopCapacitiesAndSlotWrapper mobileBreakpoint={this.props.mobileBreakpoint}>
                    {this.renderCapacitiesAndSlot()}
                  </DesktopCapacitiesAndSlotWrapper>
                  <DesktopVisible mobileBreakpoint={this.props.mobileBreakpoint}>
                    {this.renderBulkToggleSection()}
                  </DesktopVisible>
                </ModuleInformationWrapper>
              </ItemPresentationWrapper>
              {hasDescriptionComponent ? <MobileDescriptionComponent mobileBreakpoint={this.props.mobileBreakpoint}>{this.props.moduleItem.renderDescriptionComponent()}</MobileDescriptionComponent> : this.renderMobileAdditionalInformation()}
            </ItemInformationWrapper>
            <CardAddOptionsWrapper mobileBreakpoint={this.props.mobileBreakpoint}>
              {this.props.moduleItem.optionsLoading ? <SpinnerWrapper><LoadingSpinner></LoadingSpinner></SpinnerWrapper> : this.renderAddOptionsButtons(hasOptions)}
            </CardAddOptionsWrapper>
          </PresentationAndArrowWrapper>
          {showSelectedOptions && this.props.moduleItem?.modules?.length === 1 && this.renderSelectedOptions()}
      </>
    );
  }

  renderDesktop = (hasOptions) => {
    return (
      <>
        <Container
          displayType={this.props.displayType}
          mobileBreakpoint={this.props.mobileBreakpoint}
          disabled={!this.props.moduleItem.optionsLoading && (!hasOptions && !this.props.moduleItem.preventCardDisabledWhenNoOptions)}
          hasSelectedOptions={this.hasSelectedOptions()}
          color={this.props.secondaryColor}
        >
          {this.props.moduleItem.hasRecommendedOptions && <RecommandedFlag label={this.props.getLabel('options.recommanded_options')} color={this.props.secondaryColor} textColor={this.props.secondaryTextColor}></RecommandedFlag>}
          {this.renderModuleInformation(hasOptions, true, false)}
          {this.renderSubModules(false)}
        </Container>
      </>
    );
  }

  renderMobile = (hasOptions) => {
    return (
      <>
      <Container
          onClick={() => { this.setState({showMobilePopup: true});}}
          displayType={this.props.displayType}
          mobileBreakpoint={this.props.mobileBreakpoint}
          disabled={!this.props.moduleItem.optionsLoading && (!hasOptions && !this.props.moduleItem.preventCardDisabledWhenNoOptions)}
          hasSelectedOptions={this.hasSelectedOptions()}
          color={this.props.secondaryColor}
        >
          {this.renderModuleInformation(hasOptions, false, true)}
          <MobileArrow xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
            <path fille="currentColor" d="M347.2,890c-8,8-22,8-30,0c-4-4-6-10-6-15c0-6,2-11,6-15l346.3-346.6L315.5,164c-4-4-6-9-6-15c0-5,2-11,6-15c8-8,22-8,30,0  l363,363.4c8,9,8,22,0,31L347.2,890z"/>
          </MobileArrow>
        </Container>
        {this.state.showMobilePopup && <FixedMobilePopup>
            <MobilePopupHeader>
              <MobilePopupHomeIcon onClick={() => { this.setState({showMobilePopup: false});}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
                <path transform="matrix(-1,0,0,-1,1026,1024)" d="M 347.2 890 c -8 8 -22 8 -30 0 c -4 -4 -6 -10 -6 -15 c 0 -6 2 -11 6 -15 l 346.3 -346.6 L 315.5 164 c -4 -4 -6 -9 -6 -15 c 0 -5 2 -11 6 -15 c 8 -8 22 -8 30 0 l 363 363.4 c 8 9 8 22 0 31 L 347.2 890 z"/>
              </MobilePopupHomeIcon>
              <MobilePopupHome>
                {this.props.getLabel('options_screen.home')}
              </MobilePopupHome>
            </MobilePopupHeader>
            <MobileCategoryName>{this.props.categoryName}</MobileCategoryName>
            {this.renderModuleInformation(hasOptions, false, false)}
            {this.renderBulkToggleSection()}
            <MobilePopupScrollbarWrapper>
              <Scrollbars>
                <MobilePopupScrollbarContent>
                  {this.renderSelectedOptions()}
                  {this.renderSubModules(true)}
                </MobilePopupScrollbarContent>
              </Scrollbars>
            </MobilePopupScrollbarWrapper>
            {this.renderMobileAddOptionsButtons(hasOptions)}
          </FixedMobilePopup>}
      </>
    );
  }


  render = () => {
    const hasOptions = ((this.props.moduleItem.optionsAvailable?.accessories || []).length > 0 || (this.props.moduleItem.optionsAvailable?.services || []).length > 0);

    return (
      <>
        <DesktopVisible mobileBreakpoint={this.props.mobileBreakpoint}>
          {this.renderDesktop(hasOptions)}
        </DesktopVisible>
        <MobileVisible mobileBreakpoint={this.props.mobileBreakpoint}>
          {this.renderMobile(hasOptions)}
        </MobileVisible>
        {this.state.modalOpen && (
          <OptionsModal
            getLabel={this.props.getLabel}
            getAndReplaceLabel={this.props.getAndReplaceLabel}
            titleType={this.props.categoryName}
            moduleId={this.props.moduleItem.moduleId}
            mobileBreakpoint={this.props.mobileBreakpoint}
            getOptions={() => {
              return this.props.moduleItem.getOptions();
            }}
            imageUrl={this.props.moduleItem.imageUrl}
            primaryColor={this.props.primaryColor}
            primaryTextColor={this.props.primaryTextColor}
            secondaryColor={this.props.secondaryColor}
            secondaryTextColor={this.props.secondaryTextColor}
            closeModal={() => {
              this.setState({ modalOpen: false, defaultModalActiveCategoryType: null, defaultModalAccessoryToView: null, defaultOptionTypes: null, disablePreviousOnEdit: false });
            }}
            renderProductLink={this.props.renderProductLink}
            onAddOptions={(deviceIdentification, accessoryIdentification, quantity) => {
              let modulesToAccessorize = this.state.modulesForBulk;
              // Safety to ensure we will add to all accessories when the accessorize all at once is checked.
              if (this.state.bulkAccessorize) {
                modulesToAccessorize = (this.props.moduleItem?.modules || []).map((mod) => mod.deviceIdentification?.identificationKey);
              }
              return this.props.moduleItem.onAddOptions(deviceIdentification, accessoryIdentification, quantity, modulesToAccessorize);
            }}
            onDecreaseOptions={this.props.moduleItem.onDecreaseOptions}
            onRemoveOptions={this.props.moduleItem.onRemoveOptions}
            onAddSubAccessories={this.props.moduleItem.onAddSubAccessories}
            onDecreaseSubAccessories={this.props.moduleItem.onDecreaseSubAccessories}
            onRemoveSubAccessories={this.props.moduleItem.onRemoveSubAccessories}
            deviceIdentification={this.props.moduleItem.deviceIdentification}
            isSaving={this.props.isSaving}
            defaultActiveCategoryType={this.state.defaultModalActiveCategoryType}
            defaultModalAccessoryToView={this.state.defaultModalAccessoryToView}
            defaultOptionTypes={this.state.defaultOptionTypes}
            statusToFilter={this.state.statusToFilter}
            disablePreviousOnEdit={this.state.disablePreviousOnEdit}
          ></OptionsModal>
        )}
      </>
    );
  };
}

export default ModuleItem;
